import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { INewBody } from '../../components/FormMapping/validation';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export default function useRegisterMapping() {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  async function execute(distributorId: string, body: INewBody) {
    try {
      setLoading(true);
      const response = await api.post(
        `v1/backoffice/mapping/${distributorId}`,
        {
          ...body,
        },
      );

      if (response.status === 201) {
        toast.success(ToastMessages.mapping.success.registerMapping);
        history.goBack();
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.mapping.error.registerMapping);
      } else {
        toast.error(ToastMessages.general.error.genericError);
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
